import { useEffect, useState } from 'react'
import Badge from '@mui/material/Badge'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { Megaphone as MegaphoneIcon } from '@phosphor-icons/react/dist/ssr/Megaphone'
import { useOne } from '@refinedev/core'

const LAST_VIEWED_CHANGELOG_KEY = 'lastViewedChangelog'

export function ProductUpdatesButton() {
	const [newUpdates, setNewUpdates] = useState(false)

	// NOTE: could fetch from updates.micromart.com/rss.xml directly, but CORS prevents this in dev
	const { data, isLoading } = useOne<any>({
		resource: 'platform_updates',
		id: 'rss-feed',
	})

	useEffect(() => {
		if (!isLoading && data?.data) {
			checkForNewUpdates(data?.data)
		}
	}, [isLoading, data])

	const checkForNewUpdates = async (rssFeed: any) => {
		try {
			// Get the last item (most recent update)
			const items = rssFeed?.rss?.channel?.item
			const latestItem = Array.isArray(items) ? items[items.length - 1] : items

			if (!latestItem?.pubDate) return

			// Extract latest published date
			const latestPubDate = new Date(latestItem.pubDate).getTime()

			// Compare with last viewed date
			const lastViewed = Number(localStorage.getItem(LAST_VIEWED_CHANGELOG_KEY)) || 0

			if (latestPubDate > lastViewed) {
				setNewUpdates(true)
			}
		} catch (error) {
			// noop
		}
	}

	const handleOpen = () => {
		setNewUpdates(false)
		localStorage.setItem(LAST_VIEWED_CHANGELOG_KEY, String(new Date().getTime()))
		window.Notaku?.show()
	}

	return (
		<Tooltip title="What's new" describeChild>
			<Badge
				color="error"
				sx={{
					'& .MuiBadge-dot': {
						borderRadius: '50%',
						height: '10px',
						right: '6px',
						top: '6px',
						width: '10px',
					},
				}}
				variant="dot"
				invisible={!newUpdates}
			>
				<IconButton aria-label="What's new" data-test="product-updates-button" onClick={handleOpen}>
					<MegaphoneIcon />
				</IconButton>
			</Badge>
		</Tooltip>
	)
}
